"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _classnames = _interopRequireDefault(require("classnames"));

var _default = _react.default.createClass({
  displayName: "UIAbstractPageSection",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    children: _propTypes.default.node
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className"]);
    return _react.default.createElement("section", (0, _extends2.default)({}, rest, {
      className: (0, _classnames.default)('private-template__section', className)
    }), children);
  }
});

exports.default = _default;
module.exports = exports.default;